import { IDisplayInfoIcon } from '@caslink/device-client/ng-app/shared/models/types';
import { DisplayIconFactory } from './display-icon-factory.interface';
import { ICardDataViewModel } from '@caslink/device-client/ng-app/shared/models/models';

export class FanFactory implements DisplayIconFactory {
    public createDisplayIcon(item: ICardDataViewModel): IDisplayInfoIcon {
        const icon: IDisplayInfoIcon = {
            ...this.createPartialIcon(() => !!item.actualValue),
            getLabelText: () => item.displayValue || item.name,
            isLabelVisible: () => true,
            getValue: () => item.value,
        };

        return icon;
    }

    public createDisplayIconForBehavior(getIsOn: () => boolean): IDisplayInfoIcon {
        const icon: IDisplayInfoIcon = {
            ...this.createPartialIcon(getIsOn),
            getLabelText: () => '',
            isLabelVisible: () => false,
            getValue: () => getIsOn() ? 'true' : 'false',
        };

        return icon;
    }

    private createPartialIcon(getIsOn: () => boolean): Partial<IDisplayInfoIcon> {
        const conditionalCls = [{
            cls: 'rotating',
            condition: getIsOn
        }];

        const icon: Partial<IDisplayInfoIcon> = {
            conditionalCls,
            icon: getIsOn() ? 'behaviorFan' : 'behaviorFanOutlined',
        };

        return icon;
    }
}
